module.exports = __webpack_public_path__ + "static/media/w2.f70f91b5.png";